import { Box, Container, Grid, Paper } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ItemDetailViewSection, {
  Item,
} from "../../../common/item/ItemDetailViewSection";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";
import { getById } from "../../../store/hashedHotCard/queries";

const HashedHotCardView = () => {
  const classes = pageStyles();
  const session = useSession();

  const { id } = useParams<{ id: string }>();
  const hashedHotCard = useSelector(id ? getById(id) : () => null);
  const { Name, Salt, DeltaURL, FullURL } = hashedHotCard.attributes;

  const hashedHotCardInfo: Item[] = [
    {
      fieldName: "Name",
      fieldValue: Name,
    },
    {
      fieldName: "Salt",
      fieldValue: Salt,
    },
    {
      fieldName: "DeltaURL",
      fieldValue: DeltaURL,
    },
    {
      fieldName: "FullURL",
      fieldValue: FullURL,
    },
  ];

  return (
    <Layout sessionData={session}>
      <main className={classes.content as string}>
        <div className={classes.appBarSpacer as string} />
        <Container maxWidth="lg" className={classes.container as string}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View HotCard" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper as string}>
                <Box style={{ position: "relative" }}>
                  <ItemDetailViewSection
                    sectionName="HotCard Info"
                    itemData={hashedHotCardInfo}
                    lastItem
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default HashedHotCardView;
